import { getHashedIndex } from '@lyearn/core/utils/hashCode';
import { Avatar, AvatarProps, Box } from '@lyearn/ui';

interface AvatarOrInitialsProps extends Omit<AvatarProps, 'children'> {
  name: string;
}

const COLORS = [
  { color: '#F6B923', textColor: '#fff' },
  { color: '#6991FF', textColor: '#fff' },
  { color: '#B6BAEA', textColor: '#fff' },
  { color: '#82B8A1', textColor: '#fff' },
  { color: '#9B44A2', textColor: '#fff' },
  { color: '#106B8C', textColor: '#fff' },
  { color: '#9A9D3B', textColor: '#fff' },
  { color: '#EA5985', textColor: '#fff' },
  { color: '#EA773D', textColor: '#fff' },
];

const getRandomColor = (seed: string) => {
  const index = getHashedIndex(seed, COLORS.length);
  return COLORS[index];
};

const getInitials = (name: string) => {
  const words = name.split(' ').filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0].slice(0, 2);
  return words
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
};

function AvatarInitialsFallback({ name }: { name: string }) {
  const initials = getInitials(name);
  const color = getRandomColor(name);
  return (
    <Box
      className="flex h-full w-full items-center justify-center text-[10px] text-white font-semibold"
      style={{ backgroundColor: color.color, color: color.textColor }}>
      {initials}
    </Box>
  );
}

export default function AvatarOrInitials(props: AvatarOrInitialsProps) {
  const { name, ...avatarProps } = props;

  return (
    <Avatar {...avatarProps} name={name}>
      <AvatarInitialsFallback name={name} />
    </Avatar>
  );
}
